import { render, staticRenderFns } from "./DaysForConfirmWidget.vue?vue&type=template&id=5c351296&scoped=true&"
import script from "./DaysForConfirmWidget.vue?vue&type=script&lang=js&"
export * from "./DaysForConfirmWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c351296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c351296')) {
      api.createRecord('5c351296', component.options)
    } else {
      api.reload('5c351296', component.options)
    }
    module.hot.accept("./DaysForConfirmWidget.vue?vue&type=template&id=5c351296&scoped=true&", function () {
      api.rerender('5c351296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/widgets/DaysForConfirmWidget.vue"
export default component.exports